import Vue from 'vue'
import App from './App'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import globals from './globals'
import Popper from 'popper.js'
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import VueGtag from 'vue-gtag'
import VueSession from 'vue-session'
import { VueFoundationSession } from './components/session/persistence.js'
import { DateRangePickerPlugin } from '@syncfusion/ej2-vue-calendars'
import { SidebarPlugin } from '@syncfusion/ej2-vue-navigations'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import { AccordionPlugin } from '@syncfusion/ej2-vue-navigations'
import InputTag from 'vue-input-tag'
import IdleVue from 'idle-vue'
import {eventHub} from './Events'
import messenger from './components/messenger/messenger'
import VueSlider from 'vue-slider-component'
import layerRules from './components/mixins/layerRules'

// VUEX Auxiliar
import store from './store'
import UserContext from './plugins/UserContext'
import FloatingVue from 'floating-vue'
import { registerLicense } from '@syncfusion/ej2-base'

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.component('VueSlider', VueSlider)
Vue.use(VueSession)

Vue.use(VueFoundationSession)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(DropDownListPlugin)
Vue.use(UserContext)

Vue.use(DateRangePickerPlugin)
Vue.use(ButtonPlugin)
Vue.use(DialogPlugin)
Vue.use(SidebarPlugin)
Vue.use(AccordionPlugin)
Vue.use(IdleVue, {eventEmitter: eventHub, idleTime: 10000 })
Vue.use(FloatingVue)

Vue.component('input-tag', InputTag)
// Global RTL flag
Vue.mixin({
  data: globals
})

Vue.prototype.$session = Vue.prototype.$session || new VueSession()
Vue.mixin(layerRules)
registerLicense('Mgo+DSMBaFt/QHRqVVhkVVpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF5jS39Td0BhWX5aeXddRg==;Mgo+DSMBPh8sVXJ0S0J+XE9Af1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS31TdERjWHpccHVRT2VcWA==;ORg4AjUWIQA/Gnt2VVhkQlFaclZJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkdiWX5bcnRUQmlaVU0=;MTEwODYwM0AzMjMwMmUzNDJlMzBNamtwMnNlTnZVdkFPMlNjR0JMUktNQ3JoQnhKQVpaZDZoZVVEUk95ZEF3PQ==;MTEwODYwNEAzMjMwMmUzNDJlMzBDS2hmeXgyVFZ1WklQZ2ViYjdoSWRnOS9Edytic0xuU0hwL1dZaG9GeWVnPQ==;NRAiBiAaIQQuGjN/V0Z+WE9EaFtLVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RdUVhWH9fdXZVR2VcUkJy;MTEwODYwNkAzMjMwMmUzNDJlMzBIQW1QbjJKV0d4RHQrdFB0Q295SERGTnc0emZPQ0NPazkwUTlDd29mRFpJPQ==;MTEwODYwN0AzMjMwMmUzNDJlMzBGTmRia1cwK3BxWURzRDFYbVZPck5GZHRqcVM3cWFkMUFwZWhRZHNMcUFZPQ==;Mgo+DSMBMAY9C3t2VVhkQlFaclZJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkdiWX5bcnRUQ2FdWE0=;MTEwODYwOUAzMjMwMmUzNDJlMzBVVTJGZjZiUi9ZRTdHMVZpM2MvUCs0TmhlTm90VHBiOWVTRWhJTDFLUnE0PQ==;MTEwODYxMEAzMjMwMmUzNDJlMzBPd1YrV3ZFMTQrWUh0aEZ0M3JWU3ovN09teUhkLysvYnV5R2s5WDJ0SlBzPQ==;MTEwODYxMUAzMjMwMmUzNDJlMzBIQW1QbjJKV0d4RHQrdFB0Q295SERGTnc0emZPQ0NPazkwUTlDd29mRFpJPQ==');
/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  data: () => ({
    sessionExpiredWarning: false
  }),
  created() {

    // this.redirectToLogin()
  },
  methods: {
    redirectToLogin() {
      console.info('Redirecionando para a página de login...');
      this.$router.push('/home'); // Ajuste a rota conforme necessário
    }
  },
  onIdle() {
    // this.$emit('onIdle', {});
    // console.warn('Sistema inativo :(')
  },
  onActive() {
    var claims = Vue.prototype.$foundation.getTokenClaims();
    if (!claims) return;
    var current_time = new Date().getTime() / 1000;
    if (current_time > claims['exp'] && !this.sessionExpiredWarning) {
      messenger.info({ position: 'center', title: `Sua sessão expirou...faça login novamente` });
      console.info('Sua sessão expirou...faça login novamente');
      this.sessionExpiredWarning = true;
      this.$router.push('/');
    }
  }
});

// Configura o Google Analytics
Vue.use(VueGtag, {
  config: {
    id: 'G-TLB065KJ61', // Substitua pelo seu ID do Google Analytics
    params: {
      send_page_view: true
    }
  },
  appName: 'Nettoolpro',
  pageTrackerScreenviewEnabled: true,
  pageTrackerTemplate: (to) => {
    return {
      page_title: document.title,
      page_path: to.path,
      page_location: window.location.href
    }
  }
}, router);

window.vueApp = app; // Exponha a instância Vue

export var globalStore = new Vue({
  data: {
    activeLayers: [],
    layerPurchase: null,
    commonTags: [],
    dtLogOn: null,
    env: document.URL.includes('http://localhost:8080/')?'local-debug':'external'
  }
})
